/*
  Bothanica Mineral — Reveal cinematográfico da seção "Foco em benefícios"

  - Carrega GSAP + ScrollTrigger de forma assíncrona (não bloqueia o LCP),
    reusando o mesmo padrão de bm-petals.js.
  - Reveal único por seção ao entrar na viewport:
      header (stagger) → frasco/anéis (pop com back.out) → benefícios
      deslizando dos lados (esquerda/direita) → footer box.
  - Parallax sutil (scrub) no frasco no desktop, ligado ao scroll da seção.
  - Não toca no float contínuo do frasco (esse fica na imagem, via CSS); aqui
    animamos o "stage" (pai), então as duas animações compõem sem conflito.
  - Respeita prefers-reduced-motion: não anima e mantém tudo visível.
  - Idempotente e seguro: se o GSAP falhar ao carregar, o conteúdo permanece
    visível (só escondemos depois que o GSAP confirma que está pronto).
*/
(function () {
  if (window.__bmBenefitsFocusInit) return;
  window.__bmBenefitsFocusInit = true;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start() {
    var sections = document.querySelectorAll('[data-bpf-focus]');
    if (!sections.length) return;

    // Sem movimento: mantém o conteúdo estático e encerra.
    if (prefersReduced) return;

    loadGsap(function (ok) {
      if (!ok || !window.gsap || !window.ScrollTrigger) return; // fallback: visível
      var gsap = window.gsap;
      gsap.registerPlugin(window.ScrollTrigger);

      var isDesktop = window.matchMedia('(min-width: 990px)').matches;

      sections.forEach(function (section) {
        var stage = section.querySelector('.js-bpf-stage');
        var reveals = section.querySelectorAll('.js-bpf-reveal');
        var leftItems = section.querySelectorAll(
          '.js-bpf-item[data-bpf-side="left"]'
        );
        var rightItems = section.querySelectorAll(
          '.js-bpf-item[data-bpf-side="right"]'
        );

        // Deslize lateral só no desktop; no mobile (coluna) usamos fade-up.
        var dx = isDesktop ? 48 : 0;
        var dy = isDesktop ? 0 : 20;

        // Estados iniciais (escondidos só agora que o GSAP está pronto).
        if (reveals.length) gsap.set(reveals, { autoAlpha: 0, y: 24 });
        if (stage) gsap.set(stage, { autoAlpha: 0, scale: 0.82 });
        if (leftItems.length)
          gsap.set(leftItems, { autoAlpha: 0, x: -dx, y: dy });
        if (rightItems.length)
          gsap.set(rightItems, { autoAlpha: 0, x: dx, y: dy });

        var tl = gsap.timeline({
          defaults: { ease: 'power3.out' },
          scrollTrigger: {
            trigger: section,
            start: 'top 72%',
            once: true,
          },
        });

        if (reveals.length) {
          tl.to(reveals, {
            autoAlpha: 1,
            y: 0,
            duration: 0.7,
            stagger: 0.12,
          });
        }

        if (stage) {
          tl.to(
            stage,
            { autoAlpha: 1, scale: 1, duration: 1.0, ease: 'back.out(1.4)' },
            reveals.length ? '-=0.35' : 0
          );
        }

        if (leftItems.length) {
          tl.to(
            leftItems,
            { autoAlpha: 1, x: 0, y: 0, duration: 0.7, stagger: 0.14 },
            '-=0.6'
          );
        }

        if (rightItems.length) {
          tl.to(
            rightItems,
            { autoAlpha: 1, x: 0, y: 0, duration: 0.7, stagger: 0.14 },
            leftItems.length ? '<' : '-=0.6'
          );
        }

        // Parallax sutil do frasco/anéis ligado ao scroll (apenas desktop).
        // Atua só no yPercent — não conflita com scale/autoAlpha do reveal
        // nem com o float (translate3d) da imagem interna.
        if (stage && isDesktop) {
          gsap.fromTo(
            stage,
            { yPercent: -4 },
            {
              yPercent: 4,
              ease: 'none',
              scrollTrigger: {
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1,
              },
            }
          );
        }
      });

      window.ScrollTrigger.refresh();
    });
  }

  // —— Carregamento assíncrono do GSAP + ScrollTrigger (uma vez) ——
  function loadGsap(cb) {
    if (window.gsap && window.ScrollTrigger) return cb(true);

    var core = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var st =
      'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

    inject(core, function (okCore) {
      if (!okCore) return cb(false);
      inject(st, function (okSt) {
        cb(okSt);
      });
    });
  }

  function inject(src, done) {
    var existing = document.querySelector('script[src="' + src + '"]');
    if (existing) {
      if (existing.dataset.loaded === 'true') return done(true);
      existing.addEventListener('load', function () {
        done(true);
      });
      existing.addEventListener('error', function () {
        done(false);
      });
      return;
    }
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.onload = function () {
      s.dataset.loaded = 'true';
      done(true);
    };
    s.onerror = function () {
      done(false);
    };
    document.head.appendChild(s);
  }

  // Só inicia depois do load para não competir com o LCP/render inicial.
  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start, { once: true });
  }
})();
